module.exports = __webpack_public_path__ + "static/media/IMG_1465.2536d69e.JPG";